import { useDashboardViewContext } from './DashboardViewContext';
import { MultiSiteDashboard } from './MultiSiteDashboard';
import SingleSiteDashboard from './SingleSiteDashboard';

export const Dashboard = () => {
  const { canToggleDashboardView, isMultisiteDashboardToggled } =
    useDashboardViewContext();
  return canToggleDashboardView && isMultisiteDashboardToggled ? (
    <MultiSiteDashboard />
  ) : (
    <SingleSiteDashboard />
  );
};
